import React from 'react';
import { Helmet } from 'react-helmet';

import icon1 from "../../Components/Images/con1 (1).png"
import icon2 from "../../Components/Images/con1 (3).png"
import icon3 from "../../Components/Images/con1 (2).png"
import Popupform from '../../Components/Popupform/Popupform';

const Contact = () => {
    return (
        <div className="bg-white">
            <Helmet>
                <title>Contact Us - GetFast Education | Education Consultancy</title>
                <meta name="description" content="Contact GetFast Education for expert guidance on admissions to online colleges, regular colleges, and distance education programs. Reach out for personalized education counseling." />
                <meta name="keywords" content="contact GetFast Education, education consultancy contact, admissions help, college admissions guidance, online college contact" />
                <link rel="canonical" href="https://getfasteducation.com/contact" />
            </Helmet>
            {/* Banner Section */}
            <div className="bg-brand-orange py-20 px-4 text-center relative overflow-hidden">
                <div className="absolute inset-0 bg-black/10"></div>
                <div className="relative z-10 max-w-4xl mx-auto">
                    <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
                        Let’s Connect & <span className="text-orange-950">Shape Your Future!</span>
                    </h2>
                    <p className="text-white text-lg leading-relaxed opacity-90 max-w-2xl mx-auto">
                        Have questions about your education or career path? We’re here to help! <br className="hidden md:block" />
                        Reach out to our team for expert guidance and personalized support.
                    </p>
                </div>
            </div>

            {/* Intro Section */}
            <div className="container mx-auto px-4 py-20">
                <div className="text-center max-w-3xl mx-auto mb-16">
                    <h1 className="text-3xl font-bold text-gray-800 mb-4">Get in Touch with Us</h1>
                    <p className="text-gray-500 leading-relaxed">
                        We’re here to help! Whether you have questions about our services, need guidance on admissions,
                        or simply want to know more about us, feel free to reach out. Our team is ready to assist you.
                    </p>
                    <div className="w-24 h-1 bg-brand-orange mx-auto mt-6 rounded-full"></div>
                </div>

                {/* Contact Cards */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20">
                    {/* Phone */}
                    <div className="bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 text-center hover:-translate-y-2 group">
                        <div className="w-20 h-20 bg-blue-50 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-blue-500 transition-colors duration-300">
                            <img src={icon1} alt="Phone" className="w-8 h-8 object-contain filter group-hover:brightness-0 group-hover:invert transition" />
                        </div>
                        <h5 className="text-xl font-bold text-gray-800 mb-2">Contact Us</h5>
                        <a href="tel:+919773741010" className="text-gray-600 hover:text-brand-orange font-medium text-lg transition">
                            +91 977-374-1010
                        </a>
                    </div>

                    {/* Email */}
                    <div className="bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 text-center hover:-translate-y-2 group">
                        <div className="w-20 h-20 bg-orange-50 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-brand-orange transition-colors duration-300">
                            <img src={icon2} alt="Email" className="w-8 h-8 object-contain filter group-hover:brightness-0 group-hover:invert transition" />
                        </div>
                        <h5 className="text-xl font-bold text-gray-800 mb-2">Our Email Address</h5>
                        <a href="mailto:Info@getfasteducation.in" className="text-gray-600 hover:text-brand-orange font-medium text-lg transition block">
                            Info@getfasteducation.in
                        </a>
                    </div>

                    {/* Location */}
                    <div className="bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 text-center hover:-translate-y-2 group">
                        <div className="w-20 h-20 bg-green-50 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-green-500 transition-colors duration-300">
                            <img src={icon3} alt="Location" className="w-8 h-8 object-contain filter group-hover:brightness-0 group-hover:invert transition" />
                        </div>
                        <h5 className="text-xl font-bold text-gray-800 mb-2">Our Location</h5>
                        <p className="text-gray-600 font-medium">
                            536/2 Main Road, Near Shalimar Palace, Burari, Delhi - 110084
                        </p>
                    </div>
                </div>

                {/* Popup Form Integration - Wrapped nicely */}
                <div className="bg-gray-50 rounded-3xl p-8 md:p-12 mb-20 shadow-inner">
                    <div className="text-center mb-10">
                        <h2 className="text-2xl font-bold text-gray-800">Send us a Message</h2>
                        <p className="text-gray-500 text-sm mt-2">Fill out the form below and we'll get back to you shortly.</p>
                    </div>
                    {/* The Popupform component logic might need checking if it has fixed positioning or can be embedded. 
                        Assuming it works as a form block based on previous file usage. */}
                    <Popupform />
                </div>

                {/* Map */}
                <div className="rounded-3xl overflow-hidden shadow-xl border border-gray-200">
                    <iframe
                        id="iframeid"
                        title="Google Map"
                        src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d2860.616432519658!2d77.1987645!3d28.739459000000004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjjCsDQ0JzIyLjEiTiA3N8KwMTEnNTUuNiJF!5e1!3m2!1sen!2sin!4v1739450111854!5m2!1sen!2sin"
                        className="w-full h-[400px] md:h-[500px] border-0"
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>
                </div>

            </div>
        </div>
    );
}

export default Contact;
